import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useEffect, useRef } from 'react'
import { requetes } from '../api'
import { poserPastille } from '../pwa/pastille'

/**
 * Tâches nouvelles (packages/core/src/nouvelles.ts) : la pastille de l'icône de l'appli suit
 * leur nombre ; une tâche qui arrive, ou qui n'est plus nouvelle, rafraîchit les listes, où
 * elle porte « Nouvelle ». Rien à afficher ici : la navigation a sa propre pastille.
 */
export function PastilleAppli() {
  const client = useQueryClient()
  const nouvelles = useQuery(requetes.nouvellesTaches).data
  const precedente = useRef<string | null>(null)
  const nombre = nouvelles?.nombre
  const empreinte = nouvelles ? nouvelles.ids.join(',') : null

  useEffect(() => {
    if (nombre === undefined || empreinte === null) return
    poserPastille(nombre)
    if (precedente.current !== null && precedente.current !== empreinte)
      void client.invalidateQueries({
        queryKey: ['taches'],
        predicate: (q) => q.queryKey[1] !== 'nouvelles',
      })
    precedente.current = empreinte
  }, [client, nombre, empreinte])

  return null
}
